
/*
                   _ooOoo_
                  o8888888o
                  88" . "88
                  (| -_- |)
                  O\  =  /O
               ____/`---'\____
             .'  \\|     |//  `.
            /  \\|||  :  |||//  \
           /  _||||| -:- |||||-  \
           |   | \\\  -  /// |   |
           | \_|  ''\---/''  |   |
           \  .-\__  `-`  ___/-. /
         ___`. .'  /--.--\  `. . __
      ."" '<  `.___\_<|>_/___.'  >'"".
     | | :  `- \`.;`\ _ /`;.`/ - ` : | |
     \  \ `-.   \_ __\ /__ _/   .-` /  /
======`-.____`-.___\_____/___.-`____.-'======
                   `=---='
^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
         佛祖保佑       永无BUG
*/

/*
  延时函数 - ms 传入延时的时间
*/
import store from '@/store'
import {  CodeToText } from 'element-china-area-data'
const delay = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
}

/*
  获取token
*/
const getToken = () => {
  // ES6
  return store.state.auth.token
}
/**
 * 结构化 - 字符串转数组
 */
export function switchArray(Str = '', type = 'number') {
  if (!Str) return []
  // 将字符串转成数组
  const arr = Str.split(',')
  if (type === 'string') return arr
  // 将数组中的每个元素转换为数字
  const numberArray = arr.map(item => Number(item))
  return numberArray
}

/*
  防抖函数 - ms 传入延时的时间
*/

const debounce = (func, wait) => {
  let timeout;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
}
/*
  手机号码校验
*/

const isValidPhoneNumber = (phoneNumber) => {
  const phoneRegex = /^1[3-9]\d{9}$/;
  return phoneRegex.test(phoneNumber);
}


export {
  delay,
  getToken,
  debounce,
  isValidPhoneNumber
}
/**
 * 结构化 - 省市区code码转成中文
 */
export function filterArea(val) {
  if (!val) return
  typeof val === 'string' && (val = val.split(','))
  if (val[0] === '9999') return '全国'
  let v = ''
  val.map(item => {
    if (item && CodeToText[item]) {
      v += CodeToText[item]
    }
  })
  return v || '未知数据'
}
